import React, { useState } from 'react';
import { Contact } from '../../data/go2LegendeMock';
import { Copy, Check, Share2, Mail } from 'lucide-react';

interface Props {
  user: Contact;
}

export const ReferAFriend: React.FC<Props> = ({ user }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(user.loyalty_referral_code);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  const shareText = `Pridruži se Go2 Legende programu lojalnosti! Koristi moj kod ${user.loyalty_referral_code} i dobij 500 bonus bodova na prvo putovanje. Više na go2.loyero.com`;

  const handleWhatsApp = () => {
    window.open(`https://wa.me/?text=${encodeURIComponent(shareText)}`, '_blank');
  };

  const handleEmail = () => {
    const subject = 'Pozivam te u Go2 Legende program!';
    window.open(`mailto:?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(shareText)}`, '_blank');
  };

  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
      {/* Code Block */}
      <div className="bg-white rounded-xl shadow-sm p-8 border border-gray-100">
        <h3 className="text-xl font-bold text-go2-pink mb-4">Pozovi prijatelje</h3>
        <p className="text-gray-600 mb-6">
          Podeli svoj lični kod. Tvoji prijatelji dobijaju bonus dobrodošlice (500 bodova), a ti dobijaš dodatne bodove (300 bodova) svaki put kada završe svoje prvo putovanje sa Go2.
        </p>

        <div className="bg-brand-50 rounded-lg p-4 flex items-center justify-between border border-brand-100 mb-6">
          <code className="text-2xl font-mono font-bold text-brand-900 tracking-wider">
            {user.loyalty_referral_code}
          </code>
          <button
            onClick={handleCopy}
            className="p-2 hover:bg-brand-100 rounded-full transition-colors text-brand-600"
            title="Kopiraj"
          >
            {copied ? <Check className="w-6 h-6" /> : <Copy className="w-6 h-6" />}
          </button>
        </div>

        <div className="flex space-x-4">
          <button
            onClick={handleWhatsApp}
            className="flex-1 flex items-center justify-center px-4 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-green-50 hover:border-green-400 transition-colors"
          >
            <Share2 className="w-4 h-4 mr-2" />
            Podeli na WhatsApp
          </button>
          <button
            onClick={handleEmail}
            className="flex-1 flex items-center justify-center px-4 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-blue-50 hover:border-blue-400 transition-colors"
          >
            <Mail className="w-4 h-4 mr-2" />
            Podeli putem Email-a
          </button>
        </div>
      </div>

      {/* Stats Block */}
      <div className="bg-gradient-to-br from-indigo-500 to-purple-600 rounded-xl shadow-sm p-8 text-white">
        <h3 className="text-xl font-bold mb-6">Tvoja Statistika Preporuka</h3>

        <div className="grid grid-cols-2 gap-6">
          <div className="bg-white/10 rounded-lg p-4 backdrop-blur-sm">
            <div className="text-3xl font-bold mb-1">{user.loyalty_referral_count}</div>
            <div className="text-indigo-100 text-sm">Preporučenih Prijatelja</div>
          </div>
          <div className="bg-white/10 rounded-lg p-4 backdrop-blur-sm">
            <div className="text-3xl font-bold mb-1">{user.loyalty_referral_count * 300}</div>
            <div className="text-indigo-100 text-sm">Zarađeni Bodovi</div>
          </div>
        </div>

        <div className="mt-8">
          <h4 className="font-bold mb-4 border-b border-white/20 pb-2">Nedavne Preporuke</h4>
          <ul className="space-y-3 text-sm text-indigo-100">
            <li className="flex justify-between">
              <span>Sara M.</span>
              <span className="bg-green-400/20 text-green-300 px-2 py-0.5 rounded text-xs">Završeno</span>
            </li>
            <li className="flex justify-between">
              <span>Jovan D.</span>
              <span className="bg-yellow-400/20 text-yellow-300 px-2 py-0.5 rounded text-xs">Rezervisano</span>
            </li>
            <li className="flex justify-between">
              <span>Emilija V.</span>
              <span className="bg-green-400/20 text-green-300 px-2 py-0.5 rounded text-xs">Završeno</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};
